import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

import { GlobalHelper } from 'src/app/helper/global.helper';

@Component({
  selector: 'app-result-print-all-template',
  templateUrl: './result-print-all-template.component.html',
  styleUrls: ['./result-print-all-template.component.css']
})
export class ResultPrintAllTemplateComponent implements OnInit {

  @Input() modelValue: any;
  resultPrintData;
  printSetting;
  result_data;
  today = this.globalHelper.getMomentDatas('DD-MMMM-YYYY');
  orgId = this.globalHelper.getCurData('curOrgId');
  ajHospitalOrgId = _.get(this.globalHelper.getConstantsValue('app'), 'ajHospitalOrgId', '');
  totalCost;

  constructor(private globalHelper: GlobalHelper) { }

  ngOnInit() {
    this.resultPrintData = this.modelValue.patient_data;
    this.result_data = this.modelValue.pat_request;
    this.printSetting = this.modelValue.print_setting;
    this.totalCost = this.calculateTotalCost();
  }

  calculateTotalCost(): string {
    if (!this.result_data || !Array.isArray(this.result_data)) {
      return '0.00';
    }

    const sum = this.result_data.reduce((total, item) => {
      const cost = parseFloat(item.cost);
      return total + (isNaN(cost) ? 0 : cost);
    }, 0);

    return sum.toFixed(2);
  }
}
